export const createDiscountCodes = /* GraphQL */ `
  mutation CreateDiscountCodes($input: DiscountCodeInsert!) {
    createDiscountCodes(input: $input)
  }
`;
